import SidebarShell, { SidebarItem } from '@/components/sidebar/SidebarShell'
import { SharedProps } from '@/types'
import { usePage } from '@inertiajs/react'
import { useRole } from '@/hooks/useRole'
import {
  IconBuilding,
  IconCash,
  IconCreditCard,
  IconFingerprint,
  IconMessage,
  IconPrinter,
  IconReceipt,
  IconShoppingCart,
  IconTruck,
  IconUsers,
} from '@tabler/icons-react'

export default function BoutiqueSidebar() {
  const { url, props } = usePage<SharedProps>()
  const { isAdmin } = useRole()
  const organization = props.current_organization!

  const base = `/organizations/${organization.slug}`
  const settingsUrl = `${base}/settings`

  const items: SidebarItem[] = [
    {
      type: 'link',
      label: organization.name,
      href: settingsUrl,
      icon: IconBuilding,
      active: url === settingsUrl,
    },
    { type: 'divider' },
    { type: 'section', label: 'Particuliers' },
    {
      type: 'link',
      label: 'Comptoir',
      href: `${base}/comptoir_boutique`,
      icon: IconShoppingCart,
      active: url.includes('/comptoir_boutique'),
    },
    {
      type: 'link',
      label: 'Clients',
      href: `${base}/customers`,
      icon: IconUsers,
      active: url.includes('/customers'),
    },
    { type: 'section', label: 'Production' },
    {
      type: 'link',
      label: 'Commandes',
      href: `${base}/confirmed_orders`,
      icon: IconReceipt,
      active: url.includes('confirmed_orders'),
    },
    {
      type: 'link',
      label: 'Livraison',
      href: `${base}/deliveries`,
      icon: IconTruck,
      active: url.includes('/deliveries'),
    },
    {
      type: 'link',
      label: 'Envoi SMS',
      href: `${base}/notifications`,
      icon: IconMessage,
      active: url.includes('notifications'),
    },
    { type: 'section', label: 'Finance' },
    {
      type: 'link',
      label: 'Bilan Services',
      href: `${base}/spendings`,
      icon: IconCash,
      active: url.includes('spendings'),
    },
    { type: 'section', label: 'Configuration' },
    {
      type: 'link',
      label: 'Imprimantes',
      href: `${base}/printers`,
      icon: IconPrinter,
      active: url.includes('/printers'),
    },
    {
      type: 'link',
      label: 'Autorisations',
      href: `${base}/authorizations`,
      icon: IconFingerprint,
      active: url.includes('authorizations'),
    },
    {
      type: 'link',
      label: 'Abonnement',
      href: `${base}/billing`,
      icon: IconCreditCard,
      active: url.includes('/billing'),
      visible: isAdmin,
    },
  ]

  return <SidebarShell items={items} />
}
